import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_BULK_IMPORT_BREADCRUMB } from './bulkImportBreadcrumb.query';

export function BulkImportBreadcrumb() {
  const { data } = useQuery(FETCH_BULK_IMPORT_BREADCRUMB, {
    variables: { bulkImportId: useParams().bulkImportId },
  });
  const { t } = useTranslation();
  const { localizedDateTime } = useLocalization();

  return `${t('bulkImport:bulkImportOn')} ${data ? localizedDateTime(data.fetchBulkImport?.bulkImport.createdAt) : ''}`;
}
